// SPDX-License-Identifier: LicenseRef-Techsafe-Proprietary
// Copyright (c) 2026 Techsafe Teknoloji ve Muhendislik A.S.
// https://techsafe-solutions.com
// Economic rights: Techsafe A.S.
// Authors' moral rights reserved under Turkish Copyright Law (FSEK 5846).
// Mali haklar Techsafe A.S.'ye aittir; eser sahiplerinin manevi haklari saklidir (FSEK 5846).
// This content was prepared with the assistance of AI tools, reviewed by a
// human, and published by Techsafe Teknoloji ve Muhendislik A.S. The publishing
// entity is responsible for accuracy and compliance.
// Bu icerik, yapay zeka destekli araclar kullanilarak hazirlanmis, insan
// incelemesinden gecirilmis ve Techsafe Teknoloji ve Muhendislik A.S.
// tarafindan yayimlanmistir. Icerigin dogrulugundan yayimlayan kurulus
// sorumludur.
//
// Primitive component (shadcn/ui, MIT). Themed through NodeControl tokens.
// Accessibility: never rely on color alone. Callers pair a Badge with an icon
// and/or text label so state is conveyed without color perception.

import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-nc-1 rounded-md border px-nc-2 py-0.5 text-xs font-medium",
  {
    variants: {
      tone: {
        neutral: "border-border bg-muted text-muted-foreground",
        info: "border-transparent bg-nc-info/10 text-nc-info",
        success: "border-transparent bg-nc-success/10 text-nc-success",
        warning: "border-transparent bg-nc-warning/10 text-nc-warning",
        error: "border-transparent bg-nc-error/10 text-nc-error",
      },
    },
    defaultVariants: {
      tone: "neutral",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
